import { useState } from 'react';
import type { ChangeEvent } from 'react';

import { Label, Select } from '@zillow/constellation-10';

interface StringMap {
  [key: string]: string;
}

const BROKER_LICENSE_MAP: StringMap = {
  RealEstateSalesPerson: 'Real Estate Sales Person',
  RealEstateBroker: 'Real Estate Broker',
  AssociateRealEstateBroker: 'Associate Real Estate Broker',
};

type handleChangeArgs = {
  name: string;
  value: string;
};

type AgentLicenseTypeProps = {
  agentLicenseType: string;
  name?: string;
  onChange: (args: handleChangeArgs) => void;
};

const AgentLicenseType = ({ agentLicenseType, name = 'agentLicenseType', onChange }: AgentLicenseTypeProps) => {
  const [value, setValue] = useState(agentLicenseType);

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const {
      target: { name, value },
    } = event;

    setValue(value);
    onChange({ name, value });
  };

  return (
    <div data-testid="AgentLicenseType">
      <Label>License type</Label>

      <Select
        name={name}
        value={value}
        size="md"
        onChange={handleChange}
        css={{ marginBlock: '200', whiteSpace: 'pre' }}
      >
        {/* @ts-expect-error - null value is intentional for empty option */}
        <option value={null} key="no-value" aria-label="no-value" />

        {Object.keys(BROKER_LICENSE_MAP).map((key: keyof typeof BROKER_LICENSE_MAP) => {
          return (
            <option key={key} value={key} aria-label={BROKER_LICENSE_MAP[key]}>
              {BROKER_LICENSE_MAP[key]}
            </option>
          );
        })}
      </Select>
    </div>
  );
};

export { BROKER_LICENSE_MAP };

export default AgentLicenseType;
